/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-13 17:42:24
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-07-12 14:34:38
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/BraftEditor/LinkModal/index.tsx
 */
//import Modal from 'src/components/Antd/Modal/Modal';

import React from 'react';
//import { InfoCircleFilled } from '@ant-design/icons';
import LinkLibrary from 'src/constrains/LinkLibrary';
import { ContentUtils } from 'braft-utils';
import css from './css.module.less';
import {
  // Radio,
  Input,
  ModalFooter,
  Modal,
} from 'src/components/Antd';
import { EnumLinkSource } from 'src/types/common/linkType';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { sweetControlSymbolFilter } from 'src/tools/helper';
import { LinkModuleType } from '@/src/types/common/linkType';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const LinkModal = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const { onCancel, visible, editorState, onConfirm, onAfterClose, id } = props;
  const [linkType, setLinkType] = React.useState(EnumLinkSource.Internal);
  const [externalURL, setExternalURL] = React.useState('');
  const [internalLink, setInternalLink] = React.useState<any>({
    uuid: null,
    linkType: LinkModuleType.None,
    label: null,
    action: null,
  });

  const _clearStatus = () => {
    setLinkType(EnumLinkSource.Internal);
    setExternalURL('');
    setInternalLink({
      uuid: null,
      linkType: LinkModuleType.None,
      label: null,
      action: null,
    });
  };

  React.useEffect(() => {
    if (visible) {
      const { href } = ContentUtils.getSelectionEntityData(editorState, 'LINK');

      try {
        const _href = JSON.parse(href);
        const {
          //type, url,
          linkType,
          uuid,
          label,
          action,
        } = _href || {};
        // if (type === EnumLinkSource.External) {
        //   setLinkType(EnumLinkSource.External);
        //   setExternalURL(url);
        // }
        setLinkType(EnumLinkSource.Internal);
        setInternalLink({ linkType, uuid, label, action });
      } catch (e) {
        console.log('new Link');
      }
    }
  }, [visible]);

  const confirm = () => {
    const { target } = ContentUtils.getSelectionEntityData(editorState, 'LINK');
    let linkObject = {};
    if (linkType === EnumLinkSource.External) {
      linkObject = {
        type: linkType,
        url: externalURL,
      };
    }
    if (linkType === EnumLinkSource.Internal) {
      const { linkType: l } = internalLink;
      if (l === LinkModuleType.LegalPage) {
        const { item } = internalLink;
        const _link = {
          ...internalLink,
          item: {
            ...(item || {}),
            content: null,
          },
        };

        linkObject = {
          type: linkType,
          ..._link,
        };
      } else {
        linkObject = {
          type: linkType,
          ...internalLink,
        };
      }
    }
    const _a = ContentUtils.toggleSelectionLink(
      editorState,
      JSON.stringify(linkObject),
      target,
    );

    onConfirm(_a);
  };

  const renderContent = () => {
    const { linkSet } = props;
    if (linkType === EnumLinkSource.External) {
      return (
        <ItemWrapper title={getI18n('general.externalURL')}>
          <Input
            maxLength={200}
            size='large'
            value={externalURL}
            onChange={setExternalURL}
            fullyControlledFilter={sweetControlSymbolFilter}
          />
        </ItemWrapper>
      );
    }
    if (linkType === EnumLinkSource.Internal) {
      return (
        <LinkLibrary
          data={internalLink}
          onChange={setInternalLink}
          id={id || 'rich-editor-modal-links'}
          linkSet={linkSet}
          mode={'no-modal'}
        />
      );
    }
  };

  const afterClose = () => {
    _clearStatus();
    if (onAfterClose) {
      onAfterClose();
    }
  };

  return (
    <Modal
      visible={visible}
      title={getI18n('general.addlink')}
      onCancel={onCancel}
      width={500}
      cancelText={getI18n('general.cancel')}
      afterClose={afterClose}
      destroyOnClose>
      <div className={css.wrapper}>
        {/* <div className={css.linkTypeContainer}>
          <Radio
            value={linkType}
            radioList={[
              { value: EnumLinkSource.External, label: 'External Link' },
              { value: EnumLinkSource.Internal, label: 'Internal Link' },
            ]}
            onChange={(e) => {
              setLinkType(e.target.value);
            }}
          />
        </div> */}
        {renderContent()}
      </div>

      <ModalFooter
        okClassName={css.dangerousBtn}
        onOk={confirm}
        okText={getI18n('general.confirm')}
        cancelText={getI18n('general.cancel')}
        onCancel={onCancel}
      />
    </Modal>
  );
};
export default LinkModal;
